const childRoutes = (prop) => [
    {
        path: 'api-list',
        name: 'api_list',
        component: () => import('../pages/api-list/List.vue'),
        meta: { auth: true }
    }
]

const routes = [
    {
        path: '/api-manager-service',
        name: 'apiManager',
        component: () => import('../../../../layouts/VerticleLayout.vue'),
        meta: { auth: true },
        children: childRoutes('apiManager')
    }
]

export default routes
